import React from 'react';
import { cn } from '../../utils/cn';

const Toggle = React.forwardRef(({
  className,
  checked = false,
  onChange,
  disabled = false,
  label,
  description,
  id,
  ...props
}, ref) => {
  const toggleId = id || `toggle-${Math.random()?.toString(36)?.substr(2, 9)}`;

  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <div className={cn("flex items-start space-x-3", className)}>
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={label ? toggleId : undefined}
        disabled={disabled}
        onClick={handleToggle}
        className={cn(
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background",
          checked ? "bg-primary" : "bg-muted",
          disabled && "cursor-not-allowed opacity-50"
        )}
        {...props}
      >
        <span
          aria-hidden="true"
          className={cn(
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out",
            checked ? "translate-x-5" : "translate-x-0"
          )}
        />
      </button>

      {(label || description) && (
        <div className="flex-1 space-y-1">
          {label && (
            <label
              id={toggleId}
              htmlFor={toggleId}
              className={cn(
                "text-sm font-medium leading-none cursor-pointer",
                disabled ? "cursor-not-allowed opacity-70" : "text-card-foreground"
              )}
              onClick={!disabled ? handleToggle : undefined}
            >
              {label}
            </label>
          )}

          {description && (
            <p className="text-xs text-muted-foreground">
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  );
});

Toggle.displayName = 'Toggle';

export { Toggle };